export default {
  data() {
    return {
      notaDebitoResource: this.$api.notasDebitoConsulta(this.$resource),
      tipoAcaoResource: this.$api.tipoAcao(this.$resource),
      divisaoResource: this.$api.divisao(this.$resource),
      planejamentoAcaoResource: this.$api.planejamentoAcaoCadastro(this.$resource),

      camposFormulario: {
        padrao: [
          {
            labelCampo: 'numero',
            tipoCampo: 'NUMERICO',
          },
          {
            labelCampo: 'fornecedor',
            nomCampoId: 'id_fornecedor',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            async: {
              fetchFunction: (autocomplete) => this.planejamentoAcaoResource
                .buscarFornecedores({ autocomplete }),
              itemValue: 'id',
              itemText: 'codNome',
            },
          },
          {
            labelCampo: 'status',
            nomCampoId: 'status',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            async: {
              fetchFunction: () => this.notaDebitoResource
                .buscaStatus(),
              itemValue: 'status',
              itemText: 'status',
            },
          },
          {
            labelCampo: 'data_inicio_venc',
            tipoCampo: 'DATA',
          },
          {
            labelCampo: 'data_fim_venc',
            tipoCampo: 'DATA',
          },
          {
            labelCampo: 'data_inicio_cont',
            tipoCampo: 'DATA',
          },
          {
            labelCampo: 'data_fim_cont',
            tipoCampo: 'DATA',
          },
          {
            labelCampo: 'tipo_acao',
            nomCampoId: 'id_acao_tipo',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            async: {
              fetchFunction: (autocomplete) => this.tipoAcaoResource.buscarAtivos({ autocomplete }),
              itemValue: 'id',
              itemText: 'nome',
            },
          },
          {
            labelCampo: 'divisao',
            nomCampoId: 'id_divisao',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            async: {
              fetchFunction: () => this.notaDebitoResource
                .buscaDivisoes(),
              itemValue: 'id',
              itemText: 'nome',
            },
          },
          {
            labelCampo: 'origem',
            nomCampoId: 'origem',
            tipoCampo: 'LISTA',
            desAtributos: {
              lista: [
                { texto: `${this.$tc('label.contrato', 1)}`, valor: 'CONTRATO' },
                { texto: `${this.$tc('label.acao_tatica', 1)}`, valor: 'ACAO' },
              ],
              textoItem: 'texto',
              valorItem: 'valor',
            },
          },
          {
            labelCampo: 'data_inicio_apu',
            tipoCampo: 'DATA',
          },
          {
            labelCampo: 'data_fim_apu',
            tipoCampo: 'DATA',
          },
          {
            labelCampo: 'unidadenegocio',
            nomCampoId: 'id_unidadenegocio',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            async: {
              fetchFunction: (autocomplete) => this.planejamentoAcaoResource
                .buscarUnidadesNegocioEntidadesControlador({ autocomplete }),
              itemValue: 'id',
              itemText: 'nomExtensao',
            },
          },
        ],
      },
    };
  },
};
